import {
  ConversationChatStore,
  useInitConversationChatStore,
  type InitConversationChatStoreOptions,
} from "@/modules/conversation/ConversationChatStore";
import { useObjectDep } from "@deputy-ai/common/react/hooks";
import { useCreation } from "ahooks";
import { useEffect } from "react";

export function useNewConversationChatStore(
  props: InitConversationChatStoreOptions,
  options?: {
    enabled?: boolean;
    deps?: any[];
  }
) {
  const { enabled = true, deps = [] } = options ?? {};

  const allDeps = [...deps, enabled];

  const conversationStore = useCreation(() => {
    if (!enabled) {
      return undefined;
    }
    return new ConversationChatStore(props);
  }, allDeps);

  const propsDep = useObjectDep(props);
  useEffect(() => {
    conversationStore?.setOptions(props);
  }, [conversationStore, propsDep]);

  useInitConversationChatStore(conversationStore);

  return conversationStore;
}
